import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../lib/api/client';
import { PLACEHOLDER_FELLOWS, LEVEL_LABELS } from '../lib/fellowshipConstants';
import '../styles/hero.css';

// Reuses client.js's production-safe API base (falls back to
// https://api.teachgenie.ai, not localhost) — a bare
// `process.env.REACT_APP_API_URL || 'http://localhost:8000'` here meant a
// real visitor's browser silently failed to fetch the real fellows/photos
// (this env var was never actually set for a production build) and always
// fell back to the PLACEHOLDER_FELLOWS initials, even though the real
// Cloudflare-hosted photos existed.
const API_BASE = API_BASE_URL;

export default function FellowOfTheWeekCard() {
  const [fellows, setFellows] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/public/fellow-of-the-day`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.fellows?.length) setFellows(data.fellows.slice(0, 2)); })
      .catch(() => {});
  }, []);

  const displayFellows = Array.from({ length: 2 }, (_, i) => fellows[i] ?? PLACEHOLDER_FELLOWS[i]);

  return (
    <section className="fotw-mobile-section">
      <div className="container">
        <div className="fotw-card">
          <div className="fotw-grid-bg" aria-hidden="true" />

          <div className="hfs-eyebrow-row">
            <span className="hfs-eyebrow-text">✦ FELLOW OF THE WEEK ✦</span>
          </div>

          <div className="hfs-rule" />

          <h3 className="hfs-headline" aria-label="Inspire. Impact. Lead.">
            <span className="hfs-word">Inspire.</span>
            <span className="hfs-word">Impact.</span>
            <span className="hfs-word" style={{ color: '#f59e0b' }}>Lead.</span>
          </h3>

          <p className="hfs-sub">One educator. Every week. Chosen for impact.</p>

          <div className="hfs-fellows">
            {displayFellows.map((fellow, i) => (
              <div key={i} className="hfs-fellow">
                <div className="hfs-portrait-wrap">
                  <img
                    src={fellow.image_url?.startsWith('http') ? fellow.image_url : `${API_BASE}${fellow.image_url}`}
                    alt={fellow.name}
                    className="hfs-portrait"
                    onError={e => {
                      e.target.onerror = null;
                      e.target.style.display = 'none';
                      e.target.parentNode.classList.add('hfs-portrait-fallback');
                      e.target.parentNode.setAttribute('data-initials', fellow.name.charAt(0));
                    }}
                  />
                </div>
                <p className="hfs-fellow-name">{fellow.name.split(' ').slice(0, 2).join(' ')}</p>
                <span className="hfs-fellow-level">{LEVEL_LABELS[fellow.level] ?? fellow.level}</span>
              </div>
            ))}
          </div>

          <Link to="/become-a-fellow" className="hfs-cta">
            Become One of Them →
          </Link>
        </div>
      </div>
    </section>
  );
}
